<template>
  <div v-if="dataWasDownloadedSuccessfully">
      <div :id="id" :class="classes">
         <a v-for="(link, idx) in socialLinks"
            :key="idx"
            :href="link.fields.link"
            :title="link.fields.seoTitle"
            target="_blank">
          <img
            :src="link.fields.media.fields.file.url"
            class="zoom-on-hover"
            :alt="link.fields.media.fields.title">
        </a>
      </div>
  </div>
</template>

<script>
  import { getContent } from '@/javascripts/contentful';
  import Flickity from 'vue-flickity';

  export default {
    name: 'socialNetworkApp',
    props: ["entryId", "sectionId", "bgColorClass", "id", "classes"],
    data() {
      return {
        dataWasDownloadedSuccessfully: false,
        socialLinks: null,
      }
    },
    async mounted() {
      const { fields } = await getContent(this.entryId)
      if (fields) {
        this.socialLinks = fields.socialNetworkLink;
        this.dataWasDownloadedSuccessfully = true
      }
    },
  }
</script>
